module.exports = __webpack_public_path__ + "static/media/friendFamilyBannerBaggageIcon.814a7d4c.svg";